import axios from "@/plugins/axios";

let url = "/api/plugins/nice/billing";

export const billing = {
    response(data) {
        return axios.post(`${url}/response`, data).then((result) => result.data);
    },
};
